import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getFeatureList } from "./actions";

export const featureListAdapter = createEntityAdapter({
  selectId: (entity) => entity.key,
});

const initialState = featureListAdapter.getInitialState({});

export const featuresSlice = createSlice({
  name: "featureList",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getFeatureList.fulfilled, (state, action) => {
      if (action.payload.success) {
        featureListAdapter.setAll(state, action.payload.data);
      }
    });
  },
});

export default featuresSlice.reducer;
